// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetTrackerStyle_budgetTrackerSection__dp11t {
  padding: 0 24px;
}

.budgetTrackerStyle_tabContentWrp__HdDQ0 {
  margin: 20px 0;
}

.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_heading__pZ1Gm {
  margin-bottom: 8px;
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_heading__pZ1Gm h4 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  text-transform: capitalize;
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_totalBudgetAmount__J4R1I {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_totalBudgetAmount__J4R1I h5 {
  font: var(--h4);
  font-weight: 600;
  color: var(--black);
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_allocatedCol__iJAUr {
  margin: 16px 0;
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_allocatedCol__iJAUr .budgetTrackerStyle_allocatedAmount__tYEcE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_allocatedCol__iJAUr .budgetTrackerStyle_allocatedAmount__tYEcE h5 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_allocatedCol__iJAUr .budgetTrackerStyle_allocatedAmount__tYEcE h6 {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_allocatedCol__iJAUr .budgetTrackerStyle_percentUsed__LjYrB span {
  display: block;
  font: var(--body-font-four);
  color: var(--secondary-Text);
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_tbItem__z4igQ {
  padding: 16px 0 10px 0;
  border-top: 1px solid var(--border);
}
.budgetTrackerStyle_totalBudgetWrp__AZtOY .budgetTrackerStyle_tbItem__z4igQ .budgetTrackerStyle_itemLabel__NVHIS {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
  display: block;
  margin-bottom: 8px;
}

.budgetTrackerStyle_paymentOverviewList__QOUev {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.budgetTrackerStyle_paymentOverviewList__QOUev li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.budgetTrackerStyle_paymentOverviewList__QOUev li .budgetTrackerStyle_icon__McGo1 {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.budgetTrackerStyle_paymentOverviewList__QOUev li .budgetTrackerStyle_icon__McGo1 img,
.budgetTrackerStyle_paymentOverviewList__QOUev li .budgetTrackerStyle_icon__McGo1 svg {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  display: block;
}
.budgetTrackerStyle_paymentOverviewList__QOUev li .budgetTrackerStyle_content__1LIlK {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.budgetTrackerStyle_paymentOverviewList__QOUev li .budgetTrackerStyle_content__1LIlK h5 {
  font: var(--body-font-three);
  color: var(--black);
}
.budgetTrackerStyle_paymentOverviewList__QOUev li .budgetTrackerStyle_content__1LIlK h6 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--black);
}

.budgetTrackerStyle_categoryTabWrp__2UAq- .budgetTrackerStyle_cardTitle__5UZHT {
  font: var(--body-font-one);
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 16px;
}
.budgetTrackerStyle_categoryTabWrp__2UAq- .budgetTrackerStyle_categoryLeft__BnQaS {
  padding: 15px;
  border-right: 1px solid var(--border);
  height: 100%;
}
.budgetTrackerStyle_categoryTabWrp__2UAq- .budgetTrackerStyle_categoryRight__Rgrkn {
  padding: 15px;
}

.budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--border);
}
.budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D h4 {
  font: var(--body-font-one);
  font-weight: 600;
  color: var(--primary-Text);
  text-transform: capitalize;
  margin-bottom: 4px;
}
.budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D .budgetTrackerStyle_list__z24qK {
  margin: 4px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D .budgetTrackerStyle_list__z24qK li {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  position: relative;
}
.budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D .budgetTrackerStyle_list__z24qK li:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background-color: var(--border);
}

@media (max-width: 899px) {
  .budgetTrackerStyle_budgetTrackerSection__dp11t {
    padding: 16px;
  }
  .budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D {
    padding-bottom: 15px;
  }
  .budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D .budgetTrackerStyle_list__z24qK {
    gap: 10px;
  }
  .budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D .budgetTrackerStyle_list__z24qK li {
    font: var(--body-font-four);
  }
  .budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D .budgetTrackerStyle_list__z24qK li:not(:last-child)::after {
    right: -5px;
  }
}
@media (max-width: 599px) {
  .budgetTrackerStyle_categoryTabView__xUmha .budgetTrackerStyle_headerWrp__cBb2D {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/budget-tracker/budgetTrackerStyle.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAII;EACI,kBAAA;AADR;AAGQ;EACI,4BAAA;EACA,0BAAA;EACA,0BAAA;AADZ;AAKI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AAHR;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAOI;EAEI,cAAA;AANR;AAQQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AANZ;AAQY;EACI,4BAAA;EACA,gBAAA;EACA,0BAAA;AANhB;AASY;EACI,4BAAA;EACA,0BAAA;AAPhB;AAaY;EACI,cAAA;EACA,2BAAA;EACA,4BAAA;AAXhB;AAgBI;EACI,sBAAA;EACA,mCAAA;AAdR;AAiBQ;EACI,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;AAfZ;;AAqBA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAlBJ;AAoBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAlBR;AAoBQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAlBZ;AAoBY;;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAlBhB;AAsBQ;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AApBZ;AAsBY;EACI,4BAAA;EACA,mBAAA;AApBhB;AAwBY;EACI,4BAAA;EACA,gBAAA;EACA,mBAAA;AAtBhB;;AA6BI;EACI,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AA1BR;AA6BI;EACI,aAAA;EACA,qCAAA;EACA,YAAA;AA3BR;AA8BI;EACI,aAAA;AA5BR;;AAiCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,sCAAA;AA9BR;AAgCQ;EACI,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,kBAAA;AA9BZ;AAiCQ;EACI,aAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AA/BZ;AAiCY;EACI,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;AA/BhB;AAkCoB;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;AAhCxB;;AAwCA;EACI;IACI,aAAA;EArCN;EAyCM;IACI,oBAAA;EAvCV;EAyCU;IACI,SAAA;EAvCd;EAyCc;IACI,2BAAA;EAvClB;EA0CsB;IACI,WAAA;EAxC1B;AACF;AAiDA;EAGQ;IACI,sBAAA;IACA,2BAAA;IACA,uBAAA;EAjDV;AACF","sourcesContent":[".budgetTrackerSection {\r\n    padding: 0 24px;\r\n}\r\n\r\n.tabContentWrp {\r\n    margin: 20px 0;\r\n}\r\n\r\n.totalBudgetWrp {\r\n\r\n    .heading {\r\n        margin-bottom: 8px;\r\n\r\n        h4 {\r\n            font: var(--body-font-three);\r\n            color: var(--primary-Text);\r\n            text-transform: capitalize;\r\n        }\r\n    }\r\n\r\n    .totalBudgetAmount {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 8px;\r\n\r\n        h5 {\r\n            font: var(--h4);\r\n            font-weight: 600;\r\n            color: var(--black);\r\n        }\r\n    }\r\n\r\n    .allocatedCol {\r\n\r\n        margin: 16px 0;\r\n\r\n        .allocatedAmount {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            gap: 8px;\r\n\r\n            h5 {\r\n                font: var(--body-font-three);\r\n                font-weight: 600;\r\n                color: var(--primary-Text);\r\n            }\r\n\r\n            h6 {\r\n                font: var(--body-font-three);\r\n                color: var(--primary-Text);\r\n            }\r\n\r\n        }\r\n\r\n        .percentUsed {\r\n            span {\r\n                display: block;\r\n                font: var(--body-font-four);\r\n                color: var(--secondary-Text);\r\n            }\r\n        }\r\n    }\r\n\r\n    .tbItem {\r\n        padding: 16px 0 10px 0;\r\n        border-top: 1px solid var(--border);\r\n        // border-bottom: 1px solid var(--border);\r\n\r\n        .itemLabel {\r\n            font: var(--body-font-three);\r\n            font-weight: 500;\r\n            color: var(--primary-Text);\r\n            display: block;\r\n            margin-bottom: 8px;\r\n\r\n        }\r\n    }\r\n}\r\n\r\n.paymentOverviewList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n\r\n    li {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 12px;\r\n\r\n        .icon {\r\n            width: 32px;\r\n            height: 32px;\r\n            flex-shrink: 0;\r\n\r\n            img,\r\n            svg {\r\n                width: 100%;\r\n                height: 100%;\r\n                border-radius: 50%;\r\n                overflow: hidden;\r\n                display: block;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            flex: 1;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            gap: 8px;\r\n\r\n            h5 {\r\n                font: var(--body-font-three);\r\n                color: var(--black);\r\n\r\n            }\r\n\r\n            h6 {\r\n                font: var(--body-font-three);\r\n                font-weight: 600;\r\n                color: var(--black);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.categoryTabWrp {\r\n    .cardTitle {\r\n        font: var(--body-font-one);\r\n        font-weight: 600;\r\n        text-transform: capitalize;\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    .categoryLeft {\r\n        padding: 15px;\r\n        border-right: 1px solid var(--border);\r\n        height: 100%;\r\n    }\r\n\r\n    .categoryRight {\r\n        padding: 15px;\r\n    }\r\n}\r\n\r\n.categoryTabView {\r\n    .headerWrp {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 8px;\r\n        padding-bottom: 15px;\r\n        border-bottom: 1px solid var(--border);\r\n\r\n        h4 {\r\n            font: var(--body-font-one);\r\n            font-weight: 600;\r\n            color: var(--primary-Text);\r\n            text-transform: capitalize;\r\n            margin-bottom: 4px;\r\n        }\r\n\r\n        .list {\r\n            margin: 4px 0;\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 24px;\r\n\r\n            li {\r\n                font: var(--body-font-three);\r\n                font-weight: 400;\r\n                color: var(--secondary-Text);\r\n                position: relative;\r\n\r\n                &:not(:last-child) {\r\n                    &::after {\r\n                        content: \"\";\r\n                        position: absolute;\r\n                        right: -10px;\r\n                        top: 50%;\r\n                        transform: translateY(-50%);\r\n                        width: 1px;\r\n                        height: 100%;\r\n                        background-color: var(--border);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 899px) {\r\n    .budgetTrackerSection {\r\n        padding: 16px;\r\n    }\r\n\r\n    .categoryTabView {\r\n        .headerWrp {\r\n            padding-bottom: 15px;\r\n\r\n            .list {\r\n                gap: 10px;\r\n\r\n                li {\r\n                    font: var(--body-font-four);\r\n\r\n                    &:not(:last-child) {\r\n                        &::after {\r\n                            right: -5px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\r\n    .categoryTabView {\r\n        .headerWrp {\r\n            flex-direction: column;\r\n            justify-content: flex-start;\r\n            align-items: flex-start;\r\n\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"budgetTrackerSection": `budgetTrackerStyle_budgetTrackerSection__dp11t`,
	"tabContentWrp": `budgetTrackerStyle_tabContentWrp__HdDQ0`,
	"totalBudgetWrp": `budgetTrackerStyle_totalBudgetWrp__AZtOY`,
	"heading": `budgetTrackerStyle_heading__pZ1Gm`,
	"totalBudgetAmount": `budgetTrackerStyle_totalBudgetAmount__J4R1I`,
	"allocatedCol": `budgetTrackerStyle_allocatedCol__iJAUr`,
	"allocatedAmount": `budgetTrackerStyle_allocatedAmount__tYEcE`,
	"percentUsed": `budgetTrackerStyle_percentUsed__LjYrB`,
	"tbItem": `budgetTrackerStyle_tbItem__z4igQ`,
	"itemLabel": `budgetTrackerStyle_itemLabel__NVHIS`,
	"paymentOverviewList": `budgetTrackerStyle_paymentOverviewList__QOUev`,
	"icon": `budgetTrackerStyle_icon__McGo1`,
	"content": `budgetTrackerStyle_content__1LIlK`,
	"categoryTabWrp": `budgetTrackerStyle_categoryTabWrp__2UAq-`,
	"cardTitle": `budgetTrackerStyle_cardTitle__5UZHT`,
	"categoryLeft": `budgetTrackerStyle_categoryLeft__BnQaS`,
	"categoryRight": `budgetTrackerStyle_categoryRight__Rgrkn`,
	"categoryTabView": `budgetTrackerStyle_categoryTabView__xUmha`,
	"headerWrp": `budgetTrackerStyle_headerWrp__cBb2D`,
	"list": `budgetTrackerStyle_list__z24qK`
};
export default ___CSS_LOADER_EXPORT___;
